import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';

interface BreadcrumbItem {
  name: string;
  href: string;
}

const BreadcrumbNavigation = () => {
  const location = useLocation();
  
  const getBreadcrumbs = (pathname: string): BreadcrumbItem[] => {
    const pathSegments = pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [
      { name: 'Home', href: '/' }
    ];

    const pathMap: Record<string, string> = {
      'older-adults': 'For Older Adults',
      'family-members': 'For Families',
      'caregivers': 'For Professional Caregivers',
      'professional-network': 'Professional Network',
      'features': 'Features',
      'pricing': 'Pricing',
      'about': 'About',
      'blog': 'Blog',
      'privacy': 'Privacy Policy',
      'terms': 'Terms of Service',
      'contact': 'Contact Us'
    };

    let currentPath = '';
    pathSegments.forEach(segment => {
      currentPath += `/${segment}`;
      const name = pathMap[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
      breadcrumbs.push({ name, href: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(location.pathname);

  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="bg-muted/30 border-b border-border/40" aria-label="Breadcrumb">
      <div className="container mx-auto px-4 py-3">
        <ol className="flex items-center space-x-2 text-sm">
          {breadcrumbs.map((breadcrumb, index) => (
            <li key={breadcrumb.href} className="flex items-center">
              {index > 0 && (
                <ChevronRightIcon className="h-4 w-4 text-muted-foreground mx-2" aria-hidden="true" />
              )}
              {index === 0 ? (
                <Link
                  to={breadcrumb.href}
                  className="flex items-center gap-1 text-muted-foreground hover:text-primary transition-colors"
                >
                  <HomeIcon className="h-4 w-4" />
                  <span>{breadcrumb.name}</span>
                </Link>
              ) : index === breadcrumbs.length - 1 ? (
                <span className="font-medium text-foreground" aria-current="page">
                  {breadcrumb.name}
                </span>
              ) : (
                <Link
                  to={breadcrumb.href}
                  className="text-muted-foreground hover:text-primary transition-colors"
                >
                  {breadcrumb.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default BreadcrumbNavigation;